export default function MedicalInfo() {
  return (
    <div className="bg-card rounded-2xl shadow-lg p-8">
      <div className="text-center mb-6">
        <h2 className="text-2xl font-bold text-foreground">Medical Information</h2>
        <p className="text-muted-foreground text-sm mt-1">Help us better serve you</p>
      </div>

      <div className="space-y-4">
        <div className="p-4 bg-muted rounded-lg text-center text-muted-foreground">
          Medical info form coming in Phase 2
        </div>
      </div>
    </div>
  )
}
